import { MdSearchOff } from 'react-icons/md';
import './ResultsNotFound.css';

const ResultsNotFound = () => {
    return (
        <div className="results-not-found">
            <MdSearchOff size={80} color="#ccc" className="icon" />
            <div className="message">
                <h2>Nenhum registro encontrado</h2>
                <p>Desculpe, não conseguimos encontrar nenhum registro com os filtros informados.</p>
                <p>Por favor, revise as informações e tente novamente.</p>
            </div>
        </div>
    );
};

export default ResultsNotFound;
